module.exports = __webpack_public_path__ + "assets/img/platformright.07cbb8db.png";